import React from "react";
import {Line, LineChart} from "recharts";

const data = [
    {
        name: "Page A",
        uv: 9800,
        pv: 0,
        amt: 2400
    },
    {
        name: "Page B",
        uv: 4000,
        pv: 500,
        amt: 2210
    },
    {
        name: "Page C",
        uv: 500,
        pv: 4000,
        amt: 2290
    },
    {

        name: "Page D",
        uv: 0,
        pv: 50000,
        amt: 2000
    },
    {
        name: "Page E",
        uv: 500,
        pv: 4000,
        amt: 2181
    },
    {
        name: "Page F",
        uv: 4000,
        pv: 500,
        amt: 2500
    },
    {
        name: "Page G",
        uv: 9800,
        pv: 0,
        amt: 2100
    }
];

interface BpChart {
    state: string
}

export const BpChart = ({state} : BpChart) =>{

    return(
        <LineChart
            width={70}
            height={20}
            data={data}
        >
            <Line
                type="monotone"
                dataKey={state === "Low" ? "uv" : state == "High" ? "pv" : "amt"}
                stroke="#FFFFFF"
                dot={false}
            />
        </LineChart>
    )
}